import $ from "jquery";

const passwordRequirement = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = ".js-password-requirement";
    if ($(el).length === 0) return;

    $(el).each(function () {
      const $requirementBox = $(this);
      const targetSelector = $requirementBox.data("target");
      if (!targetSelector) return;

      const requirement = {
        hasUppercase: {
          selector: "[data-rule='uppercase'], #1",
          regex: /[A-Z]/,
        },
        hasSpecial: {
          selector: "[data-rule='special'], #2",
          regex: /[^A-Za-z0-9]/,
        },
        hasLower: {
          selector: "[data-rule='lowercase'], #3",
          regex: /[a-z]/,
        },
        hasMinimum8: {
          selector: "[data-rule='minimum8'], #4",
          regex: /.{8,}/,
        },
        hasNumber: {
          selector: "[data-rule='number']",
          regex: /[0-9]/,
        },
      };

      $(document).on("input", targetSelector, function () {
        const value = `${$(this).val() || ""}`;

        if (value !== "") $requirementBox.slideDown(300);
        else $requirementBox.slideUp(300);

        Object.values(requirement).forEach((req) => {
          const isValid = req.regex.test(value);
          $requirementBox.find(req.selector).prop("checked", isValid);
        });
      });
    });
  };

  init();
};

try {
  passwordRequirement();
} catch (error) {
  console.error("passwordRequirement", error);
}
